module.exports = __webpack_public_path__ + "static/media/Rectangle3.8aa7132f.png";